import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const BannerContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1.2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: 1200,
}));

export const IconContainer = styled('img')(({ theme }) => ({
  width: 45,
  height: 45,
  borderRadius: theme.shape.borderRadius * 1.6,
  marginRight: 16,
}));

export const BannerText = styled(Box)({
  flexGrow: 1,
  textAlign: 'left',
});
